import Grid from "@mui/material/Grid";
import Grow from "@mui/material/Grow";
import ReportCard from "../report_card/main";
import { ReportCardType } from "../report_card/report.types";
const AnimatedSuperSetCard = ({
  title,
  id,
  discription,
  imageUrl,
  expanded,
}: ReportCardType) => {
  return (
    <Grow in={expanded} timeout={500}>
      <Grid item xs={11.8} key={id}>
        <ReportCard
          title={title}
          discription={discription}
          imageUrl={imageUrl}
          id={`${id}`}
          onClick={() => {}}
          expanded={expanded}
        />
      </Grid>
    </Grow>
  );
};

export default AnimatedSuperSetCard;
